// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p1-0";
export var buttonContainer = "_p1-3";
export var cancelButton = "_p1-4";
export var headerSection = "_p1-6";
export var headerTitle = "_p1-9";
export var messageSideLeft = "_p1-1";
export var messageSideRight = "_p1-2";
export var orderNumberContainer = "_p1-7";
export var orderNumberLabel = "_p1-8";
export var submitButton = "_p1-5";